import React from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { publicRouteObj, privateRouteObj, onBoardingRouteObj } from './RouterConfig';
import PrivateRoute from '../components/PrivateRoute/PrivateRoute';
import OnBoardingRoute from '../components/OnBoardingRoute/OnBoardingRoute';
import PublicRoute from '../components/PublicRoute/PublicRoute';

const Routes = () => {
  const publicRoutesObj = publicRouteObj.map(route => (
    <Route
      key={route.key}
      path={route.path}
      element={
        <PublicRoute
          component={route.component}
          sidenav={route.sidenav}
          header={route.header}
        />
      }
    />
  ));

  const privateRoutesObj = privateRouteObj.map(route => {
    return (
      <Route
        key={route.key}
        path={route.path}
        element={
          <PrivateRoute
            component={route.component}
            sidenav={route.sidenav}
            header={route.header}
            footer={route.footer ? route.footer : false}
            isPrivateAndPublic={route.isPrivateAndPublic}
            routePermission={route.permission}
          />
        }
      />
    )
  });

  const onBoardingRoutesObj = onBoardingRouteObj.map(route => (
    <Route
      key={route.key}
      path={route.path}
      element={
        <OnBoardingRoute
          component={route.component}
          sidenav={route.sidenav}
          header={route.header}
        />
      }
    />
  ));

  return (
    <RouterRoutes>
      {publicRoutesObj}
      {privateRoutesObj}
      {onBoardingRoutesObj}
      {/* if user enter wrong path redirect to home page */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </RouterRoutes>
  );
};

export default Routes;
